<!-- Official documents for binding options to and from HTML and TS.
     https://www.npmjs.com/package/@asymmetrik/ngx-leaflet#api
     Set the map viewport (width and height) at main-map.component.css -->
<div id="map" class="main-map {{currentCursor}}" leaflet
        [leafletOptions]="options"
        (leafletMapReady)="onMapReady($event)"
        (leafletClick)="onMapClick($event)">
</div>
